























import { Component } from '@niknevis/vue-modules'
import Vue from 'vue'
import { AuthService } from '@/modules/user/services/auth.service'
import PinInput from '@/modules/shared/components/panel/PinInput.vue'
import {
  UserPhoneVerifyRequestModel,
  UserSendPhoneVerificationRequestModel
} from '@/modules/user/models/user-request.model'
import { Prop } from 'vue-property-decorator'
import TimerCountDown from '@/modules/common/coutn-down/components/shared/TimerCountDown.vue'

@Component({
  components: { TimerCountDown, PinInput }
})
export default class UserPhoneVerifyForm extends Vue {
  constructor(
    private readonly service: AuthService
  ) {
    super()
  }

  @Prop() phone!: string
  @Prop() duration!: number
  @Prop({ default: 4 }) digits!: number
  //loadings
  verifyLoading = false
  resendLoading = false

  verifyPhone(code) {
    this.verifyLoading = true
    this.service.phoneVerify({
        phone: this.phone,
        verification_code: code
      } as UserPhoneVerifyRequestModel
    ).onSuccess(() => {
      this.verifyLoading = false
      this.$emit('submit', true)
    }).onError(() => {
      this.verifyLoading = false
      this.$emit('submit', false)
    }).catch(() => {
      this.verifyLoading = false
      this.$emit('submit', false)
    })
  }

  resendPhoneVerification() {
    this.resendLoading = true
    this.service.resendVerificationSmsCode(
      { phone: this.phone } as UserSendPhoneVerificationRequestModel
    ).then(() => {
      this.resendLoading = false
      this.$emit('resend', true)
    })
  }
}
